import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=f5a57422&scoped=true&"
import script from "./LoadingButton.vue?vue&type=script&lang=js&"
export * from "./LoadingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a57422",
  null
  
)

export default component.exports